import React from 'react'
import Header from './../../../header/header'
import videos_list from './../Astrovideolist'
import styled from 'styled-components'

const Container = styled.div`
    width: 100%;
    margin-top: 100px;
    padding: 20px;
`

const Card = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    img{
        object-fit: cover;
        height: auto;
        width: 100%;
        border-radius: 10px;
    }
    div{
        position: absolute;
        font-size: 32px;
        right: 8px;
        bottom: 5px;
        display: none;
    }
    :hover{
        div{
            display: block;
        }
    }
`

class VideoGallery extends React.Component{
    playVideo = (id) => {
        id = parseInt(id);
        this.props.history.push(`/video-play/${id}`)
    }
    render(){
        return(
            <div>
            <Header />
            <Container>
                <div className="row">
                {videos_list.map((x) => {
                    return(
                        <div className="col-md-3 col-sm-12 col-xs-12" style={{margin: '30px 0px', display: 'flex', justifyContent: 'center'}}>
                        <Card onClick={() => {this.playVideo(x.id)}}>
                            <img src={x.preview} alt={x.name} />
                            <div>
                                <i className="fa fa-play"></i>
                            </div>
                        </Card>
                        </div>
                    )
                })}
                </div>
            </Container>
            </div>
        )
    }
}

export default VideoGallery;


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/Astrovideos/VideoGallery/VideoGallery.js